<template>
  <div>
    <div class="row">
      <div class="col-md-6 text-right">
        <span class="item-title">{{ $t('message.lblPrijem') }}{{ index + 1 }}</span>
        <button
          type="button"
          class="remove-item btn btn-danger btn-xs"
          @click="tuzemskePar5[index].deleted = true">
          <i class="fas fa-minus" />
        </button>
      </div>
    </div>

    <b-form-row>
      <b-col
        v-for="(item, key) in cols"
        :key="key">
        <b-form-group
          v-for="(i, k) in item"
          :key="k"
          :name="i.name"
          :label="i.label">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              v-bind="attrs"
              @input="tuzemskePar5[index][k] = tuzemskePar5[index][k].replace(',', '.')"
              v-model="tuzemskePar5[index][k]"
              v-on="listeners" />
          </template>
        </b-form-group>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import bFormGroup from '@/components/form-group-col5';

export default {
  components: {
    bFormGroup,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    tuzemskePar5: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      cols: {
        col1: {
          prijmy_pp: { name: `tuzemskePar5.$each.${this.index}.prijmy_pp`, label: this.$t('message.lblUP') },
          pr_dohoda: { name: `tuzemskePar5.$each.${this.index}.pr_dohoda`, label: this.$t('message.lblZTDohody') },
        },
        col2: {
          soc_poist: { name: `tuzemskePar5.$each.${this.index}.soc_poist`, label: this.$t('message.lblSoc') },
          zdrav_poist: { name: `tuzemskePar5.$each.${this.index}.zdrav_poist`, label: this.$t('message.lblZdr') },
          bonus: { name: `tuzemskePar5.$each.${this.index}.bonus`, label: this.$t('message.lblVypDanBonus') },
          dan35: { name: `tuzemskePar5.$each.${this.index}.dan35`, label: this.$t('message.lblPreddavky') },
        },
      },
    };
  },
};
</script>

<style scoped>
.p12 .form-check {
    width: 12%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.remove-item {
    display: inline !important;
    margin-left: 1em !important;
}
</style>
